import "./App.css";

import { PagingDto, SearchCriteria } from "./App.types";
import React, { useEffect, useState } from "react";

import GoogleMapReact from "google-map-react";
import Pin from "./components/pin/Pin";
import { PinProps } from "./components/pin/Pin.types";
import { Program } from "./components/program-card/ProgramCard.types";
import ProgramCard from "./components/program-card/ProgramCard";
import SearchBar from "./components/search-bar/SearchBar";

const ApiUriSearch: string = process.env.REACT_APP_PROGRAM_SEARCH_API || "";
const ApiKeySearch: string = process.env.REACT_APP_PROGRAM_SEARCH_API_KEY || "";

function App() {
    const [showingMap, setShowingMap] = useState(false);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [paging, setPaging] = useState<PagingDto>({
        pageNumber: 1,
        maxPageSize: 20,
        pageSize: 20,
    });
    const [searchCriteria, setSearchCriteria] = useState<SearchCriteria>({
        searchText: "",
        professionIds: [],
        sortStatuses: [1],
        degreeDiploma: true,
        degreeAssociate: true,
        degreeBaccalaureate: true,
        degreeCertificate: true,
        degreeMasters: true,
        addOnTracks: [],
        concentrations: [],
        levels: [],
        isInternational: false,
        paging: paging,
    });
    const [searchResults, setSearchResults] = useState<Program[]>();

    const search = (formData) => {
        setSearchCriteria({
            ...formData,
            paging: paging,
        });
        // setPinData
    };

    useEffect(() => {
        if(!loading) {
            const getPrograms = () => {
                setLoading(true);
                fetch(`${ApiUriSearch}/api/programs?code=${ApiKeySearch}`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        ...searchCriteria,
                        paging: {...paging},
                    }),
                })
                    .then((res) => {
                        const pagingHeader = res.headers.get("X-Pagination");
                        const calcTotal = pagingHeader
                            ? JSON.parse(pagingHeader).totalCount
                            : 0;
                        setTotal(calcTotal);
                        return res;
                    })
                    .then((res) => res.json())
                    .then((response) => {
                        response.forEach((prog) => {
                            prog.show = false;
                        });
                        setSearchResults(response);
                        setLoading(false);
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log("error");
                        console.log(error);
                    });
            };
            getPrograms();
        }
    }, [searchCriteria, paging]);

    const onChildClickCallback = (key: number) => {
        if (searchResults) {
            const index = searchResults.findIndex((e) => +e.id === +key);
            searchResults[index].show = searchResults[index].show
                ? !searchResults[index].show
                : true;
            setSearchResults([...searchResults]);
        }
    };

    const loadMore = () => {
        setPaging({
            ...paging,
            pageSize: paging.pageSize + 20,
            maxPageSize: paging.maxPageSize + 20,
        });
    };

    return (
        <div className="App">
            <div className="header">Find an Accredited Program</div>
            <SearchBar
                toggleMap={() => setShowingMap(!showingMap)}
                onPrint={() => console.log("Pring")}
                onSubmit={(formData) => search(formData)}
            />
            <div className="search-results">
                <div className="card-results">
                    {searchCriteria.professionIds.indexOf(2) >= 0 && (
                        <div>
                            <div className="results-warning-message">
                                Be sure to also check for Sonography programs
                                under Diagnostic Medical Sonography - Cardiac,
                                Pediatric Cardiac, and Vascular Concentrations
                            </div>
                        </div>
                    )}
                    {searchCriteria.professionIds.indexOf(4) >= 0 && (
                        <div>
                            <div className="results-warning-message">
                                Be sure to also check for Sonography programs
                                under Cardiovascular Technology
                            </div>
                        </div>
                    )}
                    {searchCriteria.sortStatuses.indexOf(5) >= 0 && (
                        <div>
                            <div className="results-warning-message">
                                Letter of Review is NOT a CAAHEP accreditation
                                status. It is a status granted by the Committee
                                on Accreditation of Educational Programs for the
                                Emergency Medical Services Professions (CoAEMSP)
                                signifying that a program seeking initial
                                accreditation has demonstrated sufficient
                                compliance with the accreditation Standards
                                through the Letter of Review Self-Study Report
                                (LSSR) and other documentation. Letter of Review
                                is recognized by the National Registry of
                                Emergency Medical Technicians (NREMT) for
                                eligibility to take the NREMT's Paramedic
                                credentialing examination(s). However, it is NOT
                                a guarantee of eventual accreditation.
                            </div>
                        </div>
                    )}
                    {searchResults && searchResults.length > 0 ? (
                        <>
                            {loading && (
                                <div className="no-result-container" style={{marginBottom: "20px"}}>
                                    <div className="no-result-header">
                                        Loading Results...
                                    </div>
                                </div>
                            )}
                            <div className="no-result-container" style={{marginBottom: "20px"}}>
                                <div className="no-result-header">
                                    {`${total} Results`}
                                </div>
                            </div>
                            {searchResults.map((program) => (
                                <ProgramCard
                                    key={program.id}
                                    program={program}
                                />
                            ))}
                            {total > searchResults.length && (
                                <div className="load-btn-container">
                                    <div>
                                        <button
                                            className="load-btn"
                                            onClick={loadMore}
                                        >
                                            {loading
                                                ? "Loading..."
                                                : "Load More"}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="no-result-container">
                            {loading ? (
                                <div className="no-result-header">
                                    Loading Results...
                                </div>
                            ) : (
                                <>
                                    <div className="no-result-header">
                                        No Results
                                    </div>
                                    <div className="no-result-message">
                                        To get more results, try broadening your
                                        search.
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </div>
                <div className={`map-results ${!showingMap && "hidden"}`}>
                    {searchResults && searchResults.length > 0 && (
                        <GoogleMapReact
                            bootstrapURLKeys={{
                                key: "AIzaSyDYBeW1RwLUrajLq-8DJoDwgb63kMcXFyA",
                            }}
                            defaultCenter={{ lat: 39.73997, lng: -104.98476 }}
                            defaultZoom={3}
                            onChildClick={onChildClickCallback}
                        >
                            {searchResults.map((pin) => {
                                if (
                                    pin.programDirector?.lat &&
                                    pin.programDirector?.lng
                                ) {
                                    return (
                                        <Pin
                                            key={pin.id}
                                            lat={pin.programDirector.lat}
                                            lng={pin.programDirector.lng}
                                            place={pin}
                                            show={pin.show}
                                        />
                                    );
                                }
                                return;
                            })}
                        </GoogleMapReact>
                    )}
                </div>
            </div>
        </div>
    );
}

export default App;
